import { api } from '@/services/client';
import { WS_SESSION_STORAGE_KEY } from '@/context/TabMonitorSessionContext';

/**
 * Returns the active workspace session id used for tabs and generated apps.
 * Never invents a random id — always resolves from the API when needed.
 */
export async function resolveWorkspaceSessionId(forceRefresh = false): Promise<string | null> {
  if (typeof sessionStorage === 'undefined') return null;

  if (!forceRefresh) {
    const cached = sessionStorage.getItem(WS_SESSION_STORAGE_KEY);
    if (cached) return cached;
  }

  try {
    const res = await api.get<{ session: { id: string } }>('/sessions/current');
    const id = res.data.session?.id;
    if (id) {
      sessionStorage.setItem(WS_SESSION_STORAGE_KEY, id);
      return id;
    }
  } catch (e) {
    console.error('Failed to resolve workspace session:', e);
  }

  return sessionStorage.getItem(WS_SESSION_STORAGE_KEY);
}

export function clearWorkspaceSessionCache(): void {
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.removeItem(WS_SESSION_STORAGE_KEY);
  }
}
